export const environment = {
	APP: "uku",
	APP_TEXT: "UKU",
  RESOURCES_URL: "https://uku-backend-service.s3.amazonaws.com",
  AUTH_API_URL: "https://api.uku.co/api/authentication-service",
  BACKEND_API_URL: "https://api.uku.co/api/backend-service",
  WALLET_API_URL: "https://api.uku.co/api/wallet-service"
};
